export default __webpack_public_path__ + "static/media/PLUS.b60354b1.svg";